<template>
<m-navbar :theme="theme.theme.headerTheme">
  <div class="model" v-if="isShowBell" @click="modelClick"></div>
  <m-navbar-brand style="float:left;">
    <i class="side-switch"
      :class="{
        'el-icon-more': !mini,
        'el-icon-more-outline': mini
      }"
      @click="handleSwitchSide"
      ></i>
  </m-navbar-brand>
  <m-nav align="right">
    <m-nav-item padding="0" title="通知消息">
      <div class="inlineBlock">
        <el-badge :hidden="unReadCount==0" :value="unReadCount" class="item" @click.native.stop.prevent="handleBellShow()" :class="{'isOpen':isShowBell}">
          <i class="fa fa-bell"></i>
        </el-badge>   
        <div class="hoverDown" v-show="isShowBell">
          <div class="hoverDown_title">通知消息</div>
          <div class="hoverDown_content" v-loading="loading">
            <div @click="rowClick(item)" v-for="(item, index) in messageList" :key="index" class="item_text">
              <div class="item_title" v-html="item.title"></div>
              <div class="item_content" v-html="item.content"></div>
            </div>
            <div v-if="unReadCount==0" style="text-align:center;line-height:200px;color:#666;">...暂无最新消息</div>
          </div>
          <div class="hoverDown_bottom">
            <span style="color:#409EFF;" @click="toAllMessage">查看全部通知</span>
          </div>
        </div> 
      </div>  
    </m-nav-item>
    <m-nav-item padding="0">
      <m-dropdown align="right" v-if="user" padding="0 10px">
        <a href="#" style="display: inline-block; padding: 0px; color: inherit">
          <!-- <img src="../assets/images/user.jpg" alt="" style="border-radius: 3px;vertical-align: middle;"> -->
          <span style="font-size:14px;color:#D1EEEE;"><i class="fa fa-user"></i> {{user.name}} | 欢迎您</span> 
          <span class="caret"></span>
        </a>
        <m-dropdown-panel>
          <!-- <m-dropdown-item>用户信息</m-dropdown-item> -->
          <m-dropdown-item @click.native="dialogVisible=true">修改密码</m-dropdown-item>
          <!-- <m-dropdown-item disabled>注销</m-dropdown-item> -->
          <div class="test-line"></div>
          <m-dropdown-item @click.native="loginOut">退出账号</m-dropdown-item>
        </m-dropdown-panel>
      </m-dropdown>
    </m-nav-item>
    <m-nav-item padding="0 5px" title="客户端下载">
      <router-link to="/download"><i class="fa fa-download"></i></router-link>
    </m-nav-item>
    <m-nav-item padding="0 5px" title="全屏">
      <a href="#" @click.stop.prevent="handleSwitchScreen">
        <i 
          class="fa" 
          :class="isFullScreen ? 'fa-compress' : 'fa-expand'"
          ></i>
      </a>
    </m-nav-item>
    <m-nav-item padding="0" title="主题设置">
      <m-dropdown align="right" padding="0 10px">
        <a href="#"  style="padding:0 0px; color: inherit">
          <i class="fa fa-gears"></i>
        </a>
        <m-dropdown-panel style="width: 200px; min-height: 100px;">
          <el-form>
            <el-form-item label="侧边栏">
              <el-switch v-model="showAside" @change="handleSwitchHideSide" />
            </el-form-item>
            <el-form-item label="主题">
              <el-select v-model="themeType" style="width: 100px">
                <el-option
                  v-for="theme in themes"
                  :key="theme.label"
                  :label="theme.label"
                  :value="theme.name"
                  ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </m-dropdown-panel>
      </m-dropdown>
    </m-nav-item>
  </m-nav>
  <el-dialog
    title="修改密码"
    :visible.sync="dialogVisible"
    width="30%"
    >
    <el-form>
      <el-form-item label="修改为" label-width="80px">
        <el-input v-model="password" placeholder="默认原密码" auto-complete="off"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitClick">确 定</el-button>
    </span>
  </el-dialog>
</m-navbar>
</template>
<script type="text/javascript">
import {messageUnreadCountURL, messageListURL, userURL, passwordURL, ifMessageURL} from '@/api/http'
import {mapActions, mapState, mapGetters} from 'vuex'
import {
  requestFullScreen,
  exitFullscreen
} from '@/utils'
import themes from './theme'

export default {
  name: 'app-header',
  data () {
    return {
      dialogVisible: false,
      mini: false,
      isFullScreen: false,
      isShowBullhorn: false,
      isShowLope: false,
      isShowBell: false,
      loading: true,
      themes,
      user: JSON.parse(sessionStorage.getItem('user')),
      themeType: '',
      showAside: true,
      messageList: [],
      theme: {theme: {headerTheme: 'info'}},
      password: '',
      unCount: 0
    }
  },
  computed: {
    ...mapGetters(['unReadCount', 'isHidden'])
  },
  watch: {
    themeType (val) {
      this.theme = this.themes.find(e => e.name === val) || {}
      this.$emit('set-theme', this.theme)
      localStorage.setItem('theme', val)
    },
    unReadCount(val) {
       this.unCount = val
    }
  },
  methods: {
    ...mapActions(['getLoginUser', 'logout']),
    modelClick() {
      this.isShowBell = false
      this.getMessage()
    },
    rowClick(row) {
      this.getMessage()
      if (!row.businessBlock) {
        this.$message.warning('该消息没有详情信息')
      } else {
        let url = ''
        if (row.url) {
          url = row.businessId  
        }
        const id = row.id           
        if (row.businessBlock=='task') {                  
          this.ifMessageTrue(id,'/todoDetail',url, '','流程已处理！可在已办理事宜中查看详情')
        } else if(row.businessBlock=='historyProcess'){        
          this.ifMessageTrue(id,'/todoDetail',url, 'process', '流程已删除')
        } else if(row.businessBlock=='notice'){        
          this.ifMessageTrue(id,'/noticeDetails',url, '', '公告已删除')
        } else if(row.businessBlock=='workLog'){        
          this.ifMessageTrue(id,'/gongZuorz',url)
        } else if(row.businessBlock=='vote'){        
          this.ifMessageTrue(id,'/voteManagement/voteDetail',url, '', '投票已删除')
        } else if(row.businessBlock=='workPlan'){        
          this.ifMessageTrue(id,'/workPlanDetai',url,'', '计划已删除')
        } else if(row.businessBlock=='schedule'){        
          this.ifMessageTrue(id,'/schedule',url)
        } else if(row.businessBlock=='commonFile'){        
          window.open(row.url)
        }
      }
    },
    ifMessageTrue (id,path,url,type,text) {
      this.$http.get(ifMessageURL+id+'/url/validate')
        .then(res => {
            if(res) {
              this.$router.push({
                path: path, 
                name: '',
                params: { 
                  id: url,
                },
                query: { 
                  id: url,
                  type: type
                }
              })
            } else {
              this.$message.warning(text)
            }
        })
        .catch(err => {
          console.log(err)
        })
    },
    loginOut () {
      this.logout()
      this.$router.push('/login')
    },
    handleSwitchSide () {
      this.mini = !this.mini
      this.$emit('switch', this.mini)
    },
    handleSwitchScreen () {
      if (this.isFullScreen) {
        exitFullscreen()
        this.isFullScreen = false
      } else {
        requestFullScreen()
        this.isFullScreen = true
      }
    },
    handleSwitchHideSide () {
      this.$emit('hide-side')
    },
    handleBellShow () {
      this.isShowBullhorn = false
      this.isShowLope = false
      this.getMessage() 
      if (this.isShowBell) {
        this.isShowBell = false            
      } else {
        this.isShowBell = true
        this.messageList = []
        this.getMessageList()      
      }
      
    },
    
    // 获取未读消息通知数量
    getMessage () {
      this.$store.dispatch('setUnReadCount')
    },
    // 获取所有消息列表
    getMessageList () {
      this.$http.post(messageListURL,{page:1,size: this.unReadCount})
        .then(res => {
          if (res.msg) {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          } else{
            this.loading = false
            this.messageList = res.data
          }         
        })
        .catch(err => {
          console.log(err)
        })
    },
    toAllMessage () {
      this.isShowBell = false
      this.getMessage()
      this.$router.push('/messageManagement')
    },
    // 修改密码
    submitClick () {
      this.$http.put(passwordURL, {password: this.password})
        .then(res => {
          if (res.msg) {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          } else {
            this.$message({
              message: '修改成功',
              type: 'success'
            });
            this.dialogVisible = false
          }
        })
    }
  },
  created () {
    this.getLoginUser()
    var theme = localStorage.getItem('theme') || 'default'
    this.themeType = theme
    this.getMessage()
  }
}
</script>
<style type="text/css" lang="less" scoped>
  .side-switch{
    display: inline-block;
    font-size: 32px;
    cursor: pointer;
    color: inherit;
    margin-top: 10px;
  }
  .side-switch:hover{
    color: #fff;
  }
  .item{
    font-size:18px;
    padding:0 20px;
    margin-right:0px;
  }
  .inlineBlock{
    display: inline-block;
    position:relative;
  }
  .isOpen{
    background-color:rgba(0, 0, 0, 0.05);
  }
  .hoverDown{
    position: absolute;
    right:-150px;
    top:50px;
    width:360px;
    height:400px;
    line-height: 30px;
    box-shadow: 0px 2px 3px 1px rgba(0, 0, 0, 0.09);
    border:1px solid #f1f1f1;
    border-radius: 3px;
    border:solid 1px #D9D9D9;
    background: #fff;
    z-index:9999999999;
  }
  .hoverDown_title{
    padding:5px 10px;
    color:#0084ff;
    border-bottom: 1px solid #f1f1f1;
  }
  .hoverDown_bottom{
    text-align: right;
    padding:5px 10px;
    position: absolute;
    bottom:0;
    left:0;
    width:100%;
    border-top: 1px solid #f1f1f1;
  }
  .hoverDown_content{
    height:310px;
    overflow-y: auto; 
    .item_title{
      color:#696969;
      font-size: 14px;
    }
    .item_content{
      color:#999;
      font-size: 12px;
      padding-left:12px;
    }
  }
  .item_text{
    color:#000;
    border-bottom:1px solid #f1f1f1;
    width:95%;
    padding:5px 0;
    margin: 0 auto;
  }
  /* 修改element-ui 基础样式*/
  .el-card__header{
    padding:0 20px;
  }
  .model{
    position:absolute;
    left:0;
    top:0;
    width:100%;
    height:100%;
    z-index:99;
  }
</style>



// WEBPACK FOOTER //
// src/components/app-header.vue